angular.module('app.grid', [])



// WEBPACK FOOTER //
// ./scripts/shared/grid/module.js